import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

export const BlackText = styled.main`
  * {
    color: ${COLORS.grayBlack};
  }
  s-box.secondary {
    background-color: #fff;
    .thank-you-resource-text-content {
      margin-bottom: 15px;
      > h1 {
        margin-bottom: 15px;
      }
      @media (min-width: 1041px) {
        min-height: 125px;
      }
      @media (max-width: 1260px) {
        min-height: 150px;
      }
      @media (max-width: 1040px) {
        min-height: 175px;
      }
      @media (max-width: 765px) {
        min-height: 225px;
      }
      @media (max-width: 599px) {
        min-height: 0px;
      }
    }
  }
`;
